import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 邀请公司名称 */
    inviteCompanyName: string = '';


    public success: boolean = false;
    info: any = {
        // adminActived: string;
        // companyId: string;
        // companyName: string;
        // contactName: string;
        // contactPhone: string;
        // email: string;
        // taxId: string;
        invitationCompanyId: '',
        /** 被邀请公司 */
        invitationCompanyName: '',
        invitationEmail: '',
        invitationUserId: '',
        inviterCompanyId: '',
        /** 邀请者的公司名 */
        inviterCompanyName: '',
        inviterUserId: '',
        inviterUserName: '',
        ticket: '',
    };
    ispwdOpen: boolean = false;
    isAgree: boolean = false;
    // countryList: {
    //     code: string;
    //     name: string;
    // }[] = [];
    // isChina = true;
    // provinceList: {
    //     code: string;
    //     countryCode: string;
    //     name: string;
    //  }[] = [];
    //  cityList: {
    //     code: string;
    //     name: string;
    //     stateCode: string;
    // }[] = [];
    // cityName: string = '';
    ticket: string = '';

    /** 当前邮箱的值 */
    currentEmail: string;
    /** 当前输入框展示状态 */
    inputState: any = {
        email: false,
        nickName: false,
        companyName: false,
        taxId: false,
        pass: false,
    };
    /** 背景图 */
    imgUrl: string = null;
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/CompanyRegister/Modules.State.ts